<template>
    <div class="public">
        <PublicHeader />
        <div class="public_contain">
            <div id="public_display">
                <router-view />
            </div>
        </div>
    </div>
</template>


<script>
import PublicHeader from '@/components/PublicHeader.vue';

export default {
    name: 'PublicLayout',
    components: {
         PublicHeader
    }
}
</script>


<style>
.public_contain {
    width: 100vw;
    min-height: calc(100vh - 50px);
    background-image: url('@/assets/pile-wood-logs.jpg');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 50px;
}

#public_display {
    width: 100%;
    padding: 10px;
    text-align: left;
}
</style>
